import React from "react";
import Photo from "../../../../components/ui/Photo";
import QuantityStepper from "../../../../components/ui/QuantityStepper";
import { Row, PhotoWrap, Texts, Name, Desc, PriceLabel } from "./FlavorRow.styles";

interface FlavorRowProps {
  name: string;
  desc?: string;
  photo?: string;
  priceLabel: React.ReactNode;
  qty: number;
  onChange: (value: number) => void;
  disabledPlus?: boolean;
  max?: number;
  /** Cardápio-vitrine (/menu): mostra o sabor e o preço, sem o seletor de quantidade. */
  readOnly?: boolean;
}

export default function FlavorRow({ name, desc, photo, priceLabel, qty, onChange, disabledPlus, max = 99, readOnly = false }: FlavorRowProps) {
  return (
    <Row $on={qty > 0}>
      <PhotoWrap>
        <Photo src={photo} label={name} radius={13} />
      </PhotoWrap>
      <Texts>
        <Name>{name}</Name>
        {desc && <Desc>{desc}</Desc>}
        <PriceLabel>{priceLabel}</PriceLabel>
      </Texts>
      {!readOnly && (
        <QuantityStepper value={qty} onChange={onChange} min={0} max={disabledPlus ? qty : max} size="sm" />
      )}
    </Row>
  );
}
